import { FormikFormFiller } from "fearless-common-ui";
import {isDev, isInternal} from "../../utils/env";

const FormFiller = (isDev() || isInternal()) ? FormikFormFiller : (() => null);
export default FormFiller;
